import {createApp} from 'vue'
import FundraisingAsideVue from './FundraisingAsideVue'
import handleComponentProps from 'foundation/js/utils/handleComponentProps'

const el = '.kb-component--fundraising-aside-vue'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((FundraisingAsideVueDOM)=>{
            const props = handleComponentProps(FundraisingAsideVue, FundraisingAsideVueDOM)
            const component = createApp(FundraisingAsideVue, props).use(Store)
            component.mount(FundraisingAsideVueDOM)
        })
    }
}